import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 箱封信息
export function unitLoadDeviceList(params) {
  return request({
    url: URL.seaExport.unitLoadDevice,
    method: 'get',
    params
  })
}

// 获取装箱列表
export function queryUnitLoadDevicesByJobUuid(data) {
  return request({
    url: URL.seaExport.queryUnitLoadDevicesByJobUuid,
    method: 'post',
    data
  })
}

